<template>
    <div class="view publish-offer">
    <CancelModal
      v-if="showModal"
      @closeModal="hideModal"
      />
    <h3 class="section-title">Publicación de oferta</h3>
    <PreOfferCard />
    <PublishCard
      @showModal="showModal=true"
      />
    </div>
</template>

<script>
import PublishCard from '@/components/cards/PublishCard'
import PreOfferCard from '@/components/cards/PreOfferCard'
import CancelModal from '@/components/modals/CancelModal'

import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'PublishOffer',
    components: {
        CancelModal,
        PublishCard,
        PreOfferCard
    },
    data: function(){
        return {
            showModal: false
        }
    },
    mounted: function(){
      this.$store.dispatch("auth/setActive", "content");
      this.fillCategories();
      this.storeRequest();
      this.setOffer(this.getOffer(this.$route.params.id)[0])
    },
    computed: {
      ...mapGetters({
        'getOffer': 'offers/getOffer'
      })
    },
    methods: {
        hideModal: function(){
          this.showModal = false
        },
        ...mapActions({
          'fillCategories': 'offers/getCategories',
          'storeRequest': 'stores/storeRequest',
          'setOffer': 'offers/setSelectedOffer'
        })
    }
}
</script>

<style lang="sass">
.view.publish-offer
  margin-top: 50px
  grid-template-columns: 80px auto repeat(2, minmax(0, 1fr)) 66px
.section-title
  grid-column-start: 2
  font-family: Montserrat
  font-size: 24px
  color: #ffffff
  margin-bottom: 48px
.view.publish-offer .card-pre-offer
  grid-column-start: 2
  margin-left: 0
  margin-right: 8px
</style>